<template>
  <div class="content">
    <div class="build-CURD">
      <div class="build-title">
        <!-- <img src="../../../assets/images/back.png" style="margin-right:20px;" @click="goBack" />
        <div style="font-size: 18px;">{{info.name}}出勤统计</div> -->
        <el-page-header @back="goBack" :content="info.name+'出勤统计'"></el-page-header>
      </div>
      <div class="build-bar">
        <div style="width:100%;height:120px;display:flex;">
          <img :src="info.idcardUrl" style="width:auto;height:12vh;margin-right:5vw;" />
          <P style="width:30px;height:120px;font-size:22px;color:#0085FF;margin:0;">人 证 合 一</P>
          <img :src="info.photoUrl" style="width:auto;height:12vh;margin-left:5vw;" />
          <p
            style="font-size:22px;color:#f00;margin-left:57px;line-height:76px;cursor: pointer;"
            @click="guifan"
          >人脸采集规范</p>
        </div>
        <div class="personInfo" style="width:100%;height:40px;display:flex;">
          <p class="name">{{info.name}}</p>
          <p class="idcard">身份证：{{info.idcard}}</p>
          <!-- <p class="attend">
            总出勤：
            <span style="font-size:20px;color:#36C635;">{{info.attendDay}}/天次</span>
          </p>
          <p class="attend">
            总出勤时长：
            <span style="font-size:20px;color:#36C635;">{{info.attendTime}}小时</span>
          </p>
          <p>
            <el-button type="primary" class="add-user" @click="addFun">导出报表</el-button>
          </p>-->
        </div>
      </div>
      <div class="build-table">
        <div style="width:700px;height:100%;position: relative;">
          <div style="width:100%;height:60px;padding:10px;text-align:left;">
            <el-date-picker
              v-model="month"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月"
              @change="monthChange"
            ></el-date-picker>
          </div>
          <div
            style="display:flex;width:100%;height:calc( 100% - 60px );flex-wrap: wrap;align-content: flex-start;padding-left: 60px;"
          >
            <div class="day-list" v-for="item in montDay" :key="item.id" @click="showDayAttr(item)">
              <span v-if="item.isToday" class="box-grey day-cell">{{item.name}}</span>
              <span v-else-if="item.status=='1'" class="box-green day-cell">{{item.name}}</span>
              <span v-else-if="item.val!=''" class="day-cell day-cell-emp">{{item.name}}</span>
            </div>
            <!-- <div class="day-list">
                  <span class="box-green day-cell">2</span>
                </div>
                <div class="day-list">
                  <span class="box-red day-cell">1</span>
                </div>
                <div class="day-list">
                  <span class="box-grey day-cell">1</span>
                </div>
                <div class="day-list">
                  <span class="box-grey day-cell">1</span>
                </div>
                <div class="day-list">
                  <span class="box-grey day-cell">1</span>
                </div>
                <div class="day-list">
                  <span class="box-grey day-cell">1</span>
                </div>
                <div class="day-list">
                  <span class="box-grey day-cell">1</span>
            </div>-->
          </div>
        </div>
        <div
          style="width:calc( 100% - 700px );height:100%;position: relative;overflow: auto;padding-left:50px;"
        >
          <ul>
            <li class="dayData-item" v-for="item in dayList" :key="item.id">
              <div class="dayItem">
                <div class="dayItem-l">
                  <img :src="item.photoFileImg" />
                </div>
                <div class="dayItem-r">
                  <div class="dayItem-r-name">{{item.projectName}}</div>
                  <div class="dayItem-r-txt">
                    <p style="color:#707070;font-weight: bold;font-size:20px;width:">班组：</p>
                    <p
                      style="font-weight: bold;font-size:20px;margin-right:30px;color:#000;"
                    >{{item.teamName}}</p>
                  </div>
                  <div class="dayItem-r-txt">
                    <p style="color:#707070;font-weight: bold;font-size:20px;width:">时间：</p>
                    <p
                      style="color:#0085FF;font-weight: bold;font-size:20px;margin-right:30px;"
                    >{{item.date}}</p>
                    <p
                      style="color:#0085FF;font-weight: bold;font-size:20px;"
                      v-if="item.status=='0'"
                    >进闸</p>
                    <p
                      style="color:#0085FF;font-weight: bold;font-size:20px;"
                      v-else-if="item.status=='1'"
                    >出闸</p>
                    <p style="color:#0085FF;font-weight: bold;font-size:20px;" v-else>其他</p>
                    <p
                      style="font-weight: bold;font-size:20px;margin-left:20px;"
                      class="font-color1"
                      v-if="item.over"
                    >{{item.temperature}}℃</p>
                    <p
                      style="font-weight: bold;font-size:20px;margin-left:20px;"
                      class="font-color2"
                      v-else
                    >{{item.temperature}}℃</p>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="info-top">
                  <span>信息上传状态:</span>
                  <span v-if="item.detuoStatus=='0'" style="color:red">未上传</span>
                  <span v-if="item.detuoStatus=='1'" style="color:red">上传临时库失败</span>
                  <span v-if="item.detuoStatus=='2'" style="color:#67C23A">上传临时库成功</span>
                  <span v-if="item.detuoStatus=='3'" style="color:red">上传正式库失败</span>
                  <span v-if="item.detuoStatus=='4'" style="color:#67C23A">上传正式库成功</span>
                </div>
                <div class="info-top">
                  <el-tooltip placement="bottom">
                    <span slot="content">原因:{{item.detuoReason}}</span>
                    <span
                      class="font-head nowrap"
                      style="width:20%;display: inline-block;"
                    >原因:{{item.detuoReason}}</span>
                  </el-tooltip>
                </div>
                <div class="info-top">
                  <el-tooltip placement="bottom">
                    <span slot="content">上传时间:{{item.detuoDate}}</span>
                    <span
                      class="font-head nowrap"
                      style="width:20%;display: inline-block;"
                    >上传时间:{{item.detuoDate}}</span>
                  </el-tooltip>
                </div>
                <div class="info-bottom">
                  <span>照片上传状态:</span>
                  <span v-if="item.detuoStatus2=='0'" style="color:red">未上传</span>
                  <span v-if="item.detuoStatus2=='1'" style="color:red">上传临时库失败</span>
                  <span v-if="item.detuoStatus2=='2'" style="color:#67C23A">上传临时库成功</span>
                  <span v-if="item.detuoStatus2=='3'" style="color:red">上传正式库失败</span>
                  <span v-if="item.detuoStatus2=='4'" style="color:#67C23A">上传正式库成功</span>
                </div>
                <div class="info-top">
                  <el-tooltip placement="bottom">
                    <span slot="content">原因:{{item.detuoReason2}}</span>
                    <div
                      class="font-head nowrap"
                      style="width:20%;display: inline-block;"
                    >原因:{{item.detuoReason2}}</div>
                  </el-tooltip>
                </div>
                <div class="info-top">
                  <el-tooltip placement="bottom">
                    <span slot="content">上传时间:{{item.detuoDate2}}</span>
                    <span
                      class="font-head nowrap"
                      style="width:20%;display: inline-block;"
                    >上传时间:{{item.detuoDate2}}</span>
                  </el-tooltip>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
  data() {
    return {
      info: {
        //查询
        name: '',
        idcard: '',
        attendDay: '',
        attendTime: '',
        photoUrl: '',
        idcardUrl: ''
      },
      searchDate: util.myTime.getCurMonth(), //所选下拉框数据
      id: '',
      groupId: '',
      month: '',
      montDay: [], //月份日期
      dayList: [], //每天数据
      personId: '',
      status: ''
    }
  },
  mounted() {
    let params = this.$route.params
    this.id = params.id
    this.personId = params.personId
    this.status = params.status
    this.month = util.myTime.getCurMonth()
    if (util.session.get('roleId') != '4') {
      this.groupId = util.session.get('proId')
    } else {
      this.groupId = util.session.get('groupId')
    }
    this.getData()
    this.getMonthData()
    this.showDayAttr({ val: util.myTime.getCurTime() })
    //this.getMonthList();
  },
  methods: {
    // 获取数据  人证合一
    getData() {
      var that = this
      myHttp
        .findAllTzAttendByPersonId({
          personId: this.personId,
          projectId: this.groupId,
          towerId: this.id,
           status: this.status
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var data = resp.data.data
              that.info.name = data.name
              that.info.idcard = data.idcard
              that.info.attendDay = data.attendDay
              that.info.attendTime = data.attendTime
              that.info.photoUrl = data.photoUrl?base.httpCtx + data.photoUrl:require('../../../assets/image/zanwutupian.png')
              that.info.idcardUrl = data.idcardUrl?base.httpCtx + data.idcardUrl:require('../../../assets/image/zanwutupian.png')
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //获取月数据
    getMonthData() {
      var that = this
      myHttp
        .findTzMonthAttendByPersonId({
          towerId: this.id,
          personId: this.personId,
          projectId: this.groupId,
          daysss: this.month + '-01',
           status: this.status
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.attendMaps
            that.getMonthList(list)
          }
        })
    },
    //获取月份日期
    getMonthList(param) {
      var all = util.myTime.getMonthDay(this.month + '-01')
      var y = this.month.split('-')[0]
      var m = parseInt(this.month.split('-')[1]) - 1
      var first = new Date(y, m, 1).getDay()
      var list = []
      var allNum = all + first
      for (var i = 0; i < allNum; i++) {
        var obj = { id: i, val: '', status: '', isToday: false }
        if (i < first) {
          list.push(obj)
        } else {
          var d = i - first + 1
          d = d < 10 ? '0' + d : d
          obj.val = this.month + '-' + d
          obj.name = i - first + 1
          obj.isToday = util.myTime.getCurTime() == obj.val ? true : false
          obj.status = param['day' + (i - first + 1)]
          list.push(obj)
        }
      }

      this.montDay = list
    },
    //监听月份修改
    monthChange(val) {
      this.getMonthData()
    },
    //返回
    goBack() {
      this.$router.go(-1)
    },
    //查看
    showDayAttr(row) {
      // findDayAttendByPersonId
      // console.log(row);
      var that = this
      myHttp
        .getTzListByIdCardAndDate({
          towerId: this.id,
          personId: this.personId,
          projectId: this.groupId,
          daysss: row.val,
          status: this.status
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.attendList || []
            // console.log(resp);
            for (var i = 0; i < list.length; i++) {
              list[i].photoFileImg = base.httpCtx + list[i].photoFile
              list[i].projectName = resp.data.data.projectName || ''
              list[i].over =
                parseFloat(list[i].temperature) > 37.3 ? false : true
              // console.log(base.httpCtx + list[i].photoFile)
            }
            that.dayList = list
          }
        })
    },
    guifan() {
      this.$router.push({ name: 'guifan' })
    }

    //导出
    // addFun() {
    //   {
    //     var year = this.searchDate.split('-')[0]
    //     var month = this.searchDate.split('-')[1]
    //     var token = this.$store.state.token
    //     window.open(
    //       myHttp.getPersonExport +
    //         '?personId=' +
    //         this.id +
    //         '&projectId=' +
    //         this.groupId +
    //         '&year1=' +
    //         year +
    //         '&month1=' +
    //         month +
    //         '&accessToken=' +
    //         token
    //     )
    //   }
    // }
  }
}
</script>
<style scoped>
@import '../../../assets/css/common.css';
</style>
<style scoped>
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  background: #fff;
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table {
  width: 100%;
  height: calc(100% - 260px);
  display: flex;
  position: relative;
}
.build-bar {
  width: 100%;
  height: 200px;
  padding: 10px 30px;
  flex-wrap: wrap;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar .el-button {
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}

.build-title {
  height: 60px;
  box-shadow: 0 0 0 0 #ddd;
  border-bottom: 5px solid #ecf0f5;
  display: flex;
  align-items: center;
  align-content: center;
  padding: 0 20px;
}
.build-title img {
  cursor: pointer;
}
.personInfo p {
  margin: 0;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-left: 20px;
  font-size: 20px;
}
.personInfo .name {
  width: 10%;
  font-weight: 600;
}
.personInfo .idcard {
  width: 30%;
}
.personInfo .attend {
  width: 20%;
  font-weight: 600;
}
.day-list {
  width: 90px;
  height: 90px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.dayData-item {
  width: 100%;
  height: 100%;
  padding: 10px;
  display: flex;
  box-shadow: 1px 2px 4px 2px #ddd;
  margin-bottom: 10px;
  flex-direction: column;
}
.dayItem {
  display: flex;
  flex-direction: row;
}
.dayItem-l {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  overflow: hidden;
}
.dayItem-l img {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  overflow: hidden;
}
.dayItem-r {
  width: calc(100% - 110px);
  height: 110px;
  padding-left: 20px;
}
.info {
  height: 200px;
  text-align: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-weight: bold;
}
.dayItem-r-name {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 28px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dayItem-r-txt {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.box-green {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  animation: border_shrink 0.75s ease-out infinite;
  margin: 8px;
  background: rgb(54, 198, 53);
  display: inline-block;
}
.box-red {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  animation: border_red 0.75s ease-out infinite;
  margin: 8px;
  background: rgb(241, 43, 44);
  display: inline-block;
}
.box-grey {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  animation: border_grey 0.75s ease-out infinite;
  margin: 8px;
  background: rgb(0, 133, 255);
  display: inline-block;
}
.day-cell {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 26px;
}
.day-cell-emp {
  color: rgba(112, 112, 112, 1);
}

@keyframes border_shrink {
  0% {
    box-shadow: 0 0px 0px 0px rgba(54, 198, 53, 0.14),
      0 0px 0px 1px rgb(54, 198, 53, 0.5);
  }
  100% {
    box-shadow: 0 0px 0px 3px rgba(54, 198, 53, 0.14),
      0 0px 0px 4px rgba(54, 198, 53, 0.5);
  }
}
@keyframes border_red {
  0% {
    box-shadow: 0 0px 0px 0px rgba(241, 43, 44, 0.14),
      0 0px 0px 1px rgb(241, 43, 44, 0.5);
  }
  100% {
    box-shadow: 0 0px 0px 3px rgba(241, 43, 44, 0.14),
      0 0px 0px 4px rgba(241, 43, 44, 0.5);
  }
}
@keyframes border_grey {
  0% {
    box-shadow: 0 0px 0px 0px rgba(0, 133, 255, 0.14),
      0 0px 0px 1px rgb(0, 133, 255, 0.5);
  }
  100% {
    box-shadow: 0 0px 0px 3px rgba(0, 133, 255, 0.14),
      0 0px 0px 4px rgba(0, 133, 255, 0.5);
  }
}
.font-color1 {
  color: #36c635;
}
.font-color2 {
  color: red;
}
.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>

<style>
.add-form .el-select .el-input {
  width: 100%;
}
</style>